export const applyStyles = (css, replace = false) => {
    const cssText = replace
        ? css.cssText.replace(/:host\s*{/g, ':root {')
        : css.cssText;

    const styleSheet = new CSSStyleSheet();
    styleSheet.replaceSync(cssText);
    document.adoptedStyleSheets = [...document.adoptedStyleSheets, styleSheet];
}